// extracted by mini-css-extract-plugin
export default {"rider_time":"riderTime_rider_time__fql4z"};